module.exports = __webpack_public_path__ + "img/David_SW_20.28b5c276.jpg";